<template>
  <div v-if="show">
    <Dropdown
      title="Manejar Estatus"
      variant="standard m-1"
      :items="
        statusTargets.map((x) => ({
          name: x.name,
          click: () => {
            setCurrentStatusTarget(x);
          },
        }))
      "
      icon="fa fa-check"
      :responsive="false"
    />
  </div>
</template>

<script>
import Dropdown from 'dropdown';
import { mapActions, mapGetters, mapState } from 'vuex';
import { statusManagementStore } from '@/components/pei/ubication-tech-assistance/_store';

export default {
  name: 'ChangeOfStatusDropdown',
  components: { Dropdown },
  computed: {
    ...mapState(statusManagementStore, ['statusTargets']),
    ...mapGetters(statusManagementStore, ['currentTabState']),
    show() {
      return this.currentTabState?.showStatusTargetDropdown || false;
    },
  },
  methods: {
    ...mapActions(statusManagementStore, ['setCurrentStatusTarget']),
  },
};
</script>

<style scoped>
::v-deep .ac-btn {
  min-height: 38px;
  margin: 0.25rem !important;
}
</style>
